module.exports = __webpack_public_path__ + "static/media/fail.b9cb6b18.jpg";